export default __webpack_public_path__ + "static/media/room2_4.9b8dbf33.jpg";